module.exports = __webpack_public_path__ + "img/img-oque-fazemos-02.186fe487.png";